import type { MeetingBodyCategoryGetAllResponse } from '@govinity/validation/public';

import { ReadOnlyApi } from '../base';

export class MeetingBodyCategoriesApi extends ReadOnlyApi<
  MeetingBodyCategoryGetAllResponse,
  object
> {
  governmentPath: string;
  governmentCode: string;

  constructor(governmentCode: string, governmentPath: string) {
    super();

    this.governmentPath = governmentPath;
    this.governmentCode = governmentCode;
  }

  getPath() {
    return `${this.governmentPath}/${this.governmentCode}/meeting-body-categories`;
  }
}
